import * as React from 'react'
import classNames from 'classnames'

import { resolveLegalLinks } from './utils'
import { PublicFooter } from './Public'
import { AuthenticatedFooter } from './Authenticated'
import { TContact } from '../../../common/validations/contractContacts'

type FooterProps = { className?: string } & (
  | {
      layout: 'public'
    }
  | {
      layout: 'authenticated'
      contacts: TContact[]
    }
)

export const Footer: React.FC<FooterProps> = ({
  className,
  layout,
  ...contacts
}) => {
  const legalLinks = resolveLegalLinks()

  return (
    <footer className={classNames('bg-common-gray-8 py-10', className)}>
      {layout === 'public' && <PublicFooter legalLinks={legalLinks} />}

      {layout === 'authenticated' && (
        <AuthenticatedFooter legalLinks={legalLinks} {...contacts} />
      )}
    </footer>
  )
}
